import React from "react";

// Custom Search Box

// Mui
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { SxProps, Theme } from "@mui/material";

// Svg
import Search from "../../assets/svg/search";

const CustomSearchBox = ({
  className,
  sx,
  inputClassName,
  icon,
  placeholder,
  dialogBody,
  searchOpen,
  handleSearchToggle,
  width,
  height,
  isIcon = false,
}: {
  className?: string;
  sx?: SxProps<Theme>;
  inputClassName?: string;
  icon?: React.ReactNode;
  placeholder?: string;
  dialogBody?: React.ReactNode;
  searchOpen?: boolean;
  handleSearchToggle?: () => void;
  width?: string;
  height?: string;
  isIcon?: boolean;
}) => {
  return (
    <Box sx={{ position: "relative" }} onClick={handleSearchToggle}>
      <Box
        className={`${className} custom_search`}
        sx={sx}
        width={width}
        height={height}>
        <input
          className={`${inputClassName} custom_search_input`}
          placeholder={placeholder}
        />
        {isIcon && <IconButton>{icon ? icon : <Search />}</IconButton>}
      </Box>

      {searchOpen && (
        <Box
          sx={{
            width: width,
            position: "absolute",
            top: height,
            left: 0,
            backgroundColor: "#fff",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            padding: "20px",
            zIndex: 1000,
          }}>
          {dialogBody}
        </Box>
      )}
    </Box>
  );
};

export default CustomSearchBox;
